var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{staticClass:"lock-check-button",attrs:{"icon":_vm.value ? 'lock' : 'lock_open',"color":"grey","icon-color":"black","variant":"flat","disabled":_vm.disabled},on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }